import { Injectable } from "@angular/core";
import { UserService } from "@main-services/user.service";
import { Paysafe3DSModalComponent } from "@modules/paysafe/components/paysafe-3ds-modal/paysafe-3ds-modal.component";
import { ModalService } from "@core-services/modal.service";
import { FiatTransaction } from "@models/transaction";
import { FinalizationTypes } from "@modules/+new/payments/features/fiat-deposit/domain/entities/finalization-types.enum";
import { config } from "@config";
import { FiatDepositConfig } from "@modules/+new/payments/features/fiat-deposit/domain/config/fiat-deposit-config";
import { CheckoutDepositData } from "@modules/checkout/entities/checkout.deposit-data";

@Injectable({
	providedIn: "any"
})
export class FiatDepositBridgeService {
	public constructor(
		private readonly userService: UserService,
		private readonly modalService: ModalService
	) {}

	public getUserId(): string {
		return this.userService.user.getId();
	}

	public openOldPaysafeModal(
		walletGuid: string,
		transactionId: string,
		paymentLink: string,
		isCheckout: boolean,
		checkoutDepositData: CheckoutDepositData
	): void {
		const data = new FiatTransaction();
		data.setId(transactionId);
		data.setFiatWalletId(walletGuid);
		data.setPaymentLink(paymentLink);

		const pendingModal = this.modalService.create(
			Paysafe3DSModalComponent,
			{ transaction: data, isCheckout: isCheckout, checkoutDepositData },
			{ backdropDismiss: false }
		);
		pendingModal.present();
	}

	public isPaysafe(finalizationType: FinalizationTypes, redirectUrl: string): boolean {
		const checkUrl = (url: string): boolean => redirectUrl.startsWith(url);
		return (
			finalizationType === FinalizationTypes.EXTERNAL &&
			(checkUrl(config.appUrl) || checkUrl(window.origin) || checkUrl(FiatDepositConfig.prodAppUrl))
		);
	}
}
